module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "100",
      "src": "images/logo-chicago-guides.jpg",
      "width": "147"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('i', [_vm._v("Permissions, A Survival Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Susan M. Bielstein")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Craft of Research")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Wayne C. Booth, Gregory G. Colomb, Joseph M. Williams, Joseph Bizup, and William T. FitzGerald")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Chicago Guide to Fact-Checking")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Brooke Borel")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Writing Abroad")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Peter Chilson and Joanne B. Mulcahy")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Immersion")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Ted Conover")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Art of Creative Research")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Philip Gerard")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Getting It Published")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("William Germano")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("What Editors Do")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Peter Ginna, editor")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Storycraft")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Jack Hart")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Behind the Book")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Chris Mackenzie Jones")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("A Poet’s Guide to Poetry")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Mary Kinzie")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Developmental Editing")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Scott Norton")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Subversive Copy Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Carol Fisher Saller")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Writer’s Diet")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Helen Sword")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c88ea3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-friedman-0003.vue
// module id = 60
// module chunks = 0